document.addEventListener('click', (event) => {
  const suggestedVariantPill = event.target.closest('[data-suggested-variant-id]');
  if (suggestedVariantPill) {
    const suggestedCard = suggestedVariantPill.closest('.product__suggested-product');
    if (!suggestedCard) return;

    suggestedCard.querySelectorAll('[data-suggested-variant-id]').forEach((pill) => {
      const isSelected = pill === suggestedVariantPill;
      pill.classList.toggle('is-selected', isSelected);
      pill.setAttribute('aria-pressed', String(isSelected));
    });

    const variantInput = suggestedCard.querySelector('.product__suggested-variant-id');
    if (variantInput) {
      variantInput.value = suggestedVariantPill.dataset.suggestedVariantId;
      variantInput.dispatchEvent(new Event('change', { bubbles: true }));
    }

    const price = suggestedCard.querySelector('.product__suggested-product-price');
    const currentPrice = suggestedCard.querySelector('.product__suggested-product-current-price');
    const comparePrice = suggestedCard.querySelector('.product__suggested-product-compare-price');
    const isOnSale = Number(suggestedVariantPill.dataset.suggestedVariantCompareCents) > Number(suggestedVariantPill.dataset.suggestedVariantPriceCents);

    price?.classList.toggle('product__suggested-product-price--sale', isOnSale);
    if (currentPrice) currentPrice.textContent = suggestedVariantPill.dataset.suggestedVariantPrice;
    if (comparePrice) {
      comparePrice.textContent = suggestedVariantPill.dataset.suggestedVariantComparePrice;
      comparePrice.classList.toggle('hidden', !isOnSale);
    }
    return;
  }

  const variantPill = event.target.closest('[data-card-variant-id]');
  if (!variantPill || variantPill.disabled) return;

  const card = variantPill.closest('.product-card-wrapper');
  if (!card) return;

  const variantInput = card.querySelector('.product-variant-id');
  if (!variantInput) return;

  card.querySelectorAll('[data-card-variant-id]').forEach((pill) => {
    const isSelected = pill === variantPill;
    pill.classList.toggle('card__variant-pill--selected', isSelected);
    pill.setAttribute('aria-pressed', String(isSelected));
  });

  variantInput.value = variantPill.dataset.cardVariantId;
  variantInput.dispatchEvent(new Event('change', { bubbles: true }));

  const price = card.querySelector('.price');
  if (!price) return;

  const currentPrice = variantPill.dataset.cardVariantPrice;
  const comparePrice = variantPill.dataset.cardVariantComparePrice;
  const isOnSale = Number(variantPill.dataset.cardVariantCompareCents) > Number(variantPill.dataset.cardVariantPriceCents);

  price.classList.toggle('price--on-sale', isOnSale);

  const regularPrice = price.querySelector('.price__regular .price-item--regular');
  const salePrice = price.querySelector('.price__sale .price-item--sale');
  const oldPrice = price.querySelector('.price__sale .price-item--regular');
  const discount = price.querySelector('.price__discount');

  if (regularPrice) regularPrice.textContent = currentPrice;
  if (salePrice) salePrice.textContent = currentPrice;
  if (oldPrice) oldPrice.textContent = comparePrice;
  if (discount) {
    discount.textContent = `${variantPill.dataset.cardVariantDiscount}% off`;
    discount.classList.toggle('hidden', !isOnSale);
  }
});
